import { useEffect, useRef, useState } from 'react'
import { Button, Col, message, Row, Tabs } from 'antd'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from '@/components/YhFormBoxVertical/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, momentFormat } from '@/utils/utils'
import { useDictModel } from '../../../../base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { YHDetailNav } from '@/components/YHDetailNav'
import { IMapInfo, YHChooseMap } from '@/components/YHChooseMap'
import { useJoinCooperate } from '../../cooperateModel'
import { FileWordOutlined } from '@ant-design/icons'
import styles from './index.module.scss'
import { getBaseImgLookUrl, getBaseWebsiteUrlUrl } from '@/utils/constants'
import moment from 'moment'
import useGlobalModel from '@/model/globalModel'
import QRCode from 'qrcode.react'
import YhTootip from '@/components/YhTootip'
export const CooperateIntentionDetails = () => {
    const { setOfficeLookInfo } = useGlobalModel()
    const { getSelectedDictOne } = useDictModel()
    const { addFormVal, editFormVal, updateAddFormVal, updateEditFormVal, getOne, cooperationAgreementForm, defaultMapData, setDefaultMapData } = useJoinCooperate()
    const { addNav, selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId])
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType)
    const formRef = useRef<IYhFormRef>()

    const formValInfo = detailsInfo.mode === 'add' ? addFormVal : editFormVal
    useEffect(() => {}, [detailsInfo])

    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode !== 'add') {
            getOne(detailsInfo.id)
        }
    }, [detailsInfo])

    //清楚缓存
    useEffect(() => {
        return () => {
            !findNav('3-1-1') && updateAddFormVal(null)
        }
    }, [selectedNavId])

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, '2-2')
    }

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        isFormItem && formRef.current?.setFieldsValue(val)
        detailsInfo.mode !== 'add' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    //地图选择
    const [chooseMapVisible, setChooseMapVisible] = useState<boolean>(false)
    const saveAddress = (data) => {
        const { addr, longitude, latitude } = data
        saveCache({ repairLng: longitude, repairLat: latitude, repairAddress: addr })
        setChooseMapVisible(false)
    }

    const onCloseMap = () => {
        setChooseMapVisible(false)
    }
    const handleChooseRepairAddress = () => {
        const { repairAddress, repairLng, repairLat } = formValInfo
        setDefaultMapData({
            name: repairAddress,
            addr: repairAddress,
            longitude: repairLng,
            latitude: repairLat,
        })
        setChooseMapVisible(true)
    }
    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues, false)
    }

    //图片变更缓存保留  保留缓存及回显表单
    const onSetFieldsValue = (formValues: { [key: string]: any }) => {
        detailsInfo.mode !== 'add' ? updateEditFormVal(formValues) : updateAddFormVal(formValues)
    }

    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '加盟商编号',
                fieldName: 'code',
                rules: [{ required: true, message: '请输入组合名称' }],
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '加盟商名称',
                fieldName: 'name',
                span: 4,
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '负责人',
                fieldName: 'contact',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系电话',
                fieldName: 'phone',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '地址',
                fieldName: 'address',
                placeholder: '请选择地址',
                rules: [{ required: true, message: '请选择报修地址' }],
                span: 4,
                disable: true,
                addonAfter: (
                    <span style={{ cursor: 'pointer', fontSize: '14px', color: '#666' }} onClick={handleChooseRepairAddress}>
                        选择地址
                    </span>
                ),
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '加盟类型',
                fieldName: 'franchiseType',
                options: getSelectedDictOne(DictCodeEnmu.FRANCHISEE),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '业务经理',
                fieldName: 'businessManager',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '经营性质',
                fieldName: 'businessNature',
                options: getSelectedDictOne(DictCodeEnmu.BUSINESS_NATURE),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '资质',
                fieldName: 'qualification',
                options: getSelectedDictOne(DictCodeEnmu.FRANCHISE_QUALIFICATION),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '加盟设备',
                fieldName: 'franchiseEquipment',
                options: getSelectedDictOne(DictCodeEnmu.FRANCHISE_EQUIPMENT),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '公司规模',
                fieldName: 'companySize',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '人员储备',
                fieldName: 'personnelReserves',
                options: getSelectedDictOne(DictCodeEnmu.PERSONNEL_RESERVES),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '主要配置',
                placeholder: '自动生成',
                fieldName: 'mainConfig',
                span: 24,
            },
        ],
    }

    const invoiceFormItem: IYhFormItemsBox = {
        title: '开票信息',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '发票抬头',
                fieldName: 'invoiceTitle',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '纳税人识别号',
                fieldName: 'licenseNo',
                span: 4,
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '企业地址',
                fieldName: 'postAddress',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '公司法人',
                fieldName: 'corporation',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '开户银行',
                fieldName: 'bank',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '银行账户',
                fieldName: 'bankAcct',
                span: 4,
            },
        ],
    }

    const customerFormItem: IYhFormItemsBox = {
        title: '统计信息',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '预存金额',
                fieldName: 'driveTypeCode',
                options: getSelectedDictOne(DictCodeEnmu.FRANCHISEE),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '消费金额',
                fieldName: 'driveTypeCode',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '订单数量',
                fieldName: 'driveTypeCode',
                options: getSelectedDictOne(DictCodeEnmu.FRANCHISEE),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '商品评价',
                fieldName: 'intervalMileage',
                span: 4,
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '退货记录',
                fieldName: 'warningMileage',
                span: 4,
            },
        ],
    }

    const agreenFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '协议名称',
                fieldName: 'fileName',
                rules: [{ required: true, message: '请输入组合名称' }],
                span: 8,
            },
            {
                type: FormItemTypeEnum.Radio,
                fieldLabel: '签署模式',
                fieldName: 'mode',
                rules: [{ required: true, message: '请选择签约模式' }],
                radioDs:[{label:'双方签署', value:'双方签署'}],
                span: 8,
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '截止时间',
                fieldName: 'endTime',
                span: 8,
                showTime: true,
                format: 'YYYY-MM-DD HH:mm:ss'
            }
        ],
    }

    const fromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        formValues: detailsInfo.mode !== 'add' ? editFormVal : addFormVal,
        onChange,
        // boxs: [baseFormItem, invoiceFormItem, customerFormItem],
        boxs: [baseFormItem, invoiceFormItem],
        disabled: true,
    }

    const agreeFromVal = editFormVal.cooperationAgreementList ? editFormVal.cooperationAgreementList[editFormVal.cooperationAgreementList.length -1] : {}
    const agreeFromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        formValues: {
            fileName: agreeFromVal.fileName,
            mode: agreeFromVal.mode,
            endTime: agreeFromVal.endTime ? moment(editFormVal.endTime) : null,
            contact: agreeFromVal.contact,
            phone: agreeFromVal.phone,
        },
        onChange,
        boxs: [agreenFormItem],
        disabled: true,
    }

    const action = (
        <>
            <Button className="mr-10" shape="round" onClick={onClose} style={{ float: 'right' }}>
                返回
            </Button>
        </>
    )

    const showAgreent = () => {
        setOfficeLookInfo({visible: true, url: getBaseImgLookUrl(cooperationAgreementForm?.md5 as string)})
    }

    return (
        <>
            <YHDetailNav title="合作加盟查看" btns={action} style={{ marginBottom: '8px' }} />
            <div style={{ width: '100%', overflow: 'hidden', padding: '20px', background: '#fff', borderRadius: '5px' }}>
                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane tab="基本信息" key="1">
                        <YhFormBox {...fromConfig} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="协议详情" key="2">
                        <div>
                            <YhFormBox {...agreeFromConfig} />
                            <div style={{padding: '0 20px'}}>
                            <p className={styles['title']}>协议文件</p>
                            <div className={styles['agreementbox']} onClick={showAgreent}>
                                <FileWordOutlined style={{ fontSize: '30px' }} /> {cooperationAgreementForm?.fileName}
                            </div>
                            <Row style={{marginBottom:"20px"}}>
                            <Col span={4}>签约链接</Col>
                            <Col span={20}><YhTootip text={`${getBaseWebsiteUrlUrl()}/protocolView.html?franchiseeCode=${editFormVal?.code}`} style={{width: "100%"}}/></Col>
                        </Row>
                        <Row >
                            <Col span={4}>签约二维码</Col>
                            <Col span={20}>
                                <QRCode
                                    value={`${getBaseWebsiteUrlUrl()}/protocolView.html?franchiseeCode=${editFormVal?.code}`} // 生成二维码的内容
                                    size={100} // 二维码的大小
                                    fgColor="#000000" // 二维码的颜色
                                    // imageSettings={{ // 中间有图片logo
                                    //   src: logo,
                                    //   height: 60,
                                    //   width: 60,
                                    //   excavate: true
                                    // }}
                                />
                            </Col>
                        </Row>
                            </div>
                        </div>
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </>
    )
}
